import { RectRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { CanvasPickerContribution, CanvasRectPicker } from "../constants";

import { DefaultCanvasRectPicker } from "./rect-picker";

let loadRectPick = !1;

export function bindRectCanvasPickerContribution(container) {
    loadRectPick || (loadRectPick = !0, container.bind(CanvasRectPicker).toDynamicValue((() => new DefaultCanvasRectPicker(resolveContainerBinding(container, RectRender)))).inSingletonScope(), 
    container.bind(CanvasPickerContribution).toService(CanvasRectPicker));
}
//# sourceMappingURL=rect-module.js.map
